var map = {
	"./AboutUsCards": 3438,
	"./AboutUsCards.js": 3438,
	"./Accordion": 7449,
	"./Accordion.js": 7449,
	"./Faq": 6190,
	"./Faq.js": 6190,
	"./Gallery": 8548,
	"./Gallery.js": 8548,
	"./HPS1": 1678,
	"./HPS1.js": 1678,
	"./HPS2": 3620,
	"./HPS2.js": 3620,
	"./HPS3": 2664,
	"./HPS3.js": 2664,
	"./HPS4": 6767,
	"./HPS4.js": 6767,
	"./HPS5": 85,
	"./HPS5.js": 85,
	"./HPS6": 7205,
	"./HPS6.js": 7205,
	"./ModesOfTeachingCards": 4857,
	"./ModesOfTeachingCards.js": 4857,
	"./SlideShow": 726,
	"./SlideShow.js": 726,
	"./SwiperSlide": 2911,
	"./SwiperSlide.js": 2911,
	"./assets/blob.png": 2763,
	"./assets/boards.png": 7956,
	"./assets/cloud.png": 4137,
	"./assets/doubtclear.png": 440,
	"./assets/events/donation.jpeg": 639,
	"./assets/events/pub_spe_work.jpeg": 6723,
	"./assets/events/public_speaking_workshop.jpeg": 4819,
	"./assets/events/vadvivaad.jpeg": 2206,
	"./assets/events/webinar_perfect_score.jpeg": 2925,
	"./assets/experiencedteachers.png": 233,
	"./assets/faq.png": 3130,
	"./assets/gallery/1.jpeg": 5440,
	"./assets/gallery/2.jpeg": 6721,
	"./assets/gallery/3.jpeg": 6689,
	"./assets/gallery/4.jpeg": 8292,
	"./assets/gallery/5.jpeg": 4634,
	"./assets/gallery/6.jpeg": 3203,
	"./assets/gallery/7.jpeg": 4116,
	"./assets/gallery/8.jpeg": 2575,
	"./assets/gallery/9.jpeg": 2862,
	"./assets/home.png": 4797,
	"./assets/homepage1.png": 1150,
	"./assets/homepage2.png": 6998,
	"./assets/offline.png": 5627,
	"./assets/online.png": 1927,
	"./assets/process.png": 5660,
	"./assets/reading.png": 5970,
	"./assets/scholarship.png": 2343,
	"./assets/smallbatches.png": 2259,
	"./assets/stressfree.png": 4966,
	"./assets/testimonials/adrika.PNG": 8489,
	"./assets/testimonials/anjali.PNG": 6618,
	"./assets/testimonials/ashwani.PNG": 1965,
	"./assets/testimonials/madhurima.PNG": 6526,
	"./assets/testimonials/om.PNG": 3027,
	"./assets/video.png": 7438,
	"./assets/video/thumb.jpeg": 3616,
	"./assets/video/vid.webm": 7460,
	"./css/Faq.css": 5952,
	"./css/HPS1.css": 2381,
	"./css/HPS2.css": 375,
	"./css/HPS3.css": 8751,
	"./css/HPS4.css": 5215,
	"./css/HPS5.css": 52,
	"./css/HPS6.css": 5758,
	"./css/gallery.css": 1856,
	"./css/slideshow.css": 994,
	"./questions": 7337,
	"./questions.js": 7337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2813;